import { getBullyingDefence } from '@api/bullyingDefence';
import { slugify } from '@lib/helpers';


export const getBullyingDefencePaths = async () => {
  const strapiBiases = await getBullyingDefence();

  const paths =
    strapiBiases?.data?.map(({ attributes }) => {
      const number = attributes.number;
      const name = slugify(attributes.title);
      return {
        params: { bias: `${number}-${name}` },
      };
    }) ?? [];

  return paths;
};

